import React, { useState } from 'react';
import { isNil } from 'lodash';
import { PlusCircleFilled, QuestionCircleFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import EPTierTooltip from '@/comp/common/EPTierTooltip';
import {
  interestedPackageEnum,
  DeviceConnectivity,
  ControlModeEnum,
} from '@/constants/enums';
import { useStores } from '@/hooks/use-stores';
import CompressorIcon from '@/comp/common/icons/CompressorIcon';
import ConnectivityIcon from '../MapBuilder/components/ConnectivityIcon/ConnectivityIcon';

import { ContainerNewControllerTier, CreateNewContainer, ModalWrapperNewControllerTier } from './styled';
import { MaintenanceSwitch } from './ToggleSwitches/MaintenanceSwitch';

type Props = { compressorName: string };

const CreateNewControllerTier = observer(({ compressorName }: Props) => {
  const { t } = useTranslation();
  const { stationStore } = useStores();
  const [isTierRequestConfirmationModalOpen, setIsTierRequestConfirmationModalOpen] = useState(false);

  const onClickSignUp = () => {
    stationStore.updateRequestTier({
      emailRequestTypeOfInterestedPackage: interestedPackageEnum.ADDITIONAL_SENSORS,
      emailRequestButtonClicked: '-+ button',
      emailRequestWhichScreen: 'SCC',
    });
    setIsTierRequestConfirmationModalOpen(true);
  };

  return (
    <ModalWrapperNewControllerTier>
      <ContainerNewControllerTier>
        <div className="top-row top-padding">
          <div className="compressor-type-container">
            <CompressorIcon width={22} height={22} />
            <div className="compressor-type-label">Comp</div>
          </div>
          <div className="compressor-title">
            <div className="name ellipsis">{`${t('Compressor')} ${compressorName}`}</div>
            <div className="model ellipsis">{`${t('Compressor Type')}`}</div>
          </div>
          <div className="connectivity-icon-wrapper">
            <div className="icons-row">
              <ConnectivityIcon
                controlMode={ControlModeEnum.Controllable}
                connectivity={DeviceConnectivity.NoState}
                messages={null}
                width={24}
                height={24}
              />
              {<QuestionCircleFilled/>}
            </div>
            <div className="status-name">{"N/A"}</div>
          </div>
        </div>
        <div className="horizontal-border" />

        <div className="middle-row-container">
            <CreateNewContainer>
              <EPTierTooltip
                title={t('expandYourStation')}
                textPart1={t('addCompressor')}
                textPart2={t('startIntegrationProcess')}
                tooltipPlacement="bottom"
                tooltipWidth={330}
                initialIsTierRequestModalOpen={isTierRequestConfirmationModalOpen}
                emailRequestTypeOfInterestedPackage={interestedPackageEnum.ADDITIONAL_COMPRESSORS}
                emailRequestButtonClicked={'tooltip'}
                emailRequestWhichScreen={'SCC'}
              >
                <div onClick={onClickSignUp}>
                  <PlusCircleFilled />
                </div>
              </EPTierTooltip>
              <p className="create-label">{`${t('AddNewCompressor')}`}</p>
            </CreateNewContainer>
        </div>

        <div className="horizontal-border" />

        <div className="bottom-row bottom-padding">
          <div className="bottom-left-container">
            <div className="flex-row-centered">
              <div className="metric-container">
                <div className="rpm-text">{`${t('RPM')}`}</div>
                <div className="rpm-value-box">
                  <span className="rpm-value">{'__'}</span>
                  <span className="rpm-unit">{'%'}</span>
                </div>
              </div>
            </div>
          </div>

          {!isNil('isMainNetanase') && (
            <>
              <div className="toggle-status-box">
                <MaintenanceSwitch inMaintenance={false} deviceId={'Create New'} />
              </div>
            </>
          )}
        </div>
      </ContainerNewControllerTier>
    </ModalWrapperNewControllerTier>
  );
});

export default CreateNewControllerTier;
